import React, { useState } from "react";
import secureLocalStorage from "react-secure-storage";
import AddRemovePacksAndChannels from "../../FormFields/AddRemovePacksChannels/Home/home";
import ModPackFilterConfirmation from "../../FormFields/AddRemovePacksChannels/ModPackConfirmationComponent/ModPackFilterConfirmation";

export default function MessageA63(props) {
  const { text_data } = props.item;

  const { add, drop, filter } = text_data;

  const addChannelList = add?.channels?.channelList;
  const addPackList = add?.packsWithChannel?.packList;

  const dropChannelList = drop?.channels?.channelList;
  const dropPackList = drop?.packsWithChannel?.packList;

  //new

  const selectedLanguagesProps = filter.language.selectedLanguages;

  const allLanguagesProps = filter.language.listOfLanguages;

  const selectedGenresProps = filter.genre.selectedGenre;

  const allGenresProps = filter.genre.listOfGenre;

  const selectedHDSDProps = filter?.hdOrSd;

  const code = secureLocalStorage.getItem("specialCode");

  const [apllied, setApplied] = useState(false);

  const handleFilterApplied = () => {
    setApplied(true);
  };

  const handleFilterClickHere = (code, data, tag) => {
    //  console.log(code,data,tag);
    //used to modify filters from packs and selection component
  };

  const onHandleSubmit = (code, data, tag) => {
    console.log("A63data,tag", code, data, tag);
    props.handleClick(code, data, tag);
  };

  return (
    <>
      {addChannelList === undefined &&
      addPackList === undefined &&
      dropChannelList === undefined &&
      dropPackList === undefined ? null : !apllied ? (
        <AddRemovePacksAndChannels
          addChannelList={addChannelList}
          addPackList={addPackList}
          dropChannelList={dropChannelList}
          dropPackList={dropPackList}
          filters={{ language: "", genre: "", hdOrSd: selectedHDSDProps }}
          prioratizePacks={add?.fullyMatchedPacks}
          selectedHd={filter?.hdOrSd}
          selectedLanguagesProps={selectedLanguagesProps}
          allLanguagesProps={allLanguagesProps}
          selectedGenresProps={selectedGenresProps}
          allGenresProps={allGenresProps}
          onClickFilter={(code, data, tag) =>
            handleFilterClickHere(code, data, tag)
          }
          onClickSubmit={(code, data, tag) => {
            onHandleSubmit(code, data, tag);
          }}
          filterTag="A58"
          filterToggle={(data) => {
            handleFilterApplied(data);
          }}
          tag={props?.tag}
          code={code}
          confirmCode={props.confirmCode}
        />
      ) : (
        <ModPackFilterConfirmation
          addChannelLabel={"Add Selected Channels"}
          addChannelListData={
            JSON.parse(localStorage.getItem("modPacks"))?.addChannelNames
          }
          addPackLabel={"Add Selected packs"}
          addPackListData={
            JSON.parse(localStorage.getItem("modPacks"))?.addPackNames
          }
          dropChannelLabel={"Drop Selected Channels"}
          dropChannelListData={
            JSON.parse(localStorage.getItem("modPacks"))?.dropChannelNames
          }
          dropPackLabel={"Drop Selected packs"}
          dropPackListData={
            JSON.parse(localStorage.getItem("modPacks"))?.dropPackNames
          }
          from={"A63"}
        />
      )}
    </>
  );
}
